<!-- eslint-disable vue/multi-word-component-names -->
<script setup lang="ts">
import { ref } from "vue";
import { useMainStore } from "../store";
import type { Lead, QuizData, QuestionAnswer, UrlLogic, UrlVariant } from '../types';
import sha256 from "crypto-js/sha256";
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';


const store = useMainStore();
const quizData = store.quizData as QuizData;
const gate = store.gateData || {};
const form = ref(store.formLead);

const handleSubmit = async () => {
  const lead = store.setLead() as unknown as Lead;

  lead.name = form.value.name;
  lead.email = form.value.email;
  lead.external_id = sha256(form.value.email).toString();
  lead.hashed_email = sha256(form.value.email).toString();
  lead.hashed_name = sha256(form.value.name).toString();
  lead.phone = form.value.phone;

  // !!! ATTENTION !!!
  // We are just sending the lead to the leadclump-quiz-api and not checking if the lead is valid (because it's faster)
  // We will check if the lead is valid in the leadclump-quiz-api and also on the landing page (to fire client side pixels)
  // !!! ATTENTION !!!

  // const site = domain;
  // const leadCheckResponse = await store.checkLead(lead.email, site);
  // const isLeadCheckValid = store.isLeadCheckValid(leadCheckResponse as { valid: boolean; safe: boolean });
  // if (!isLeadCheckValid) {
  //   if (!window.dataLayer) window.dataLayer = [];
  //   window.dataLayer.push({ event: 'invalidLead', e: lead.email, lead });
  // }

  await store.createLead(lead);

  const additionalParams = {
    utm_source: lead.utm_source,
    utm_medium: lead.utm_medium,
    utm_campaign: lead.utm_campaign,
    utm_content: lead.utm_content,
    utm_term: lead.utm_term,
    fbclid: lead.fbclid,
    gclid: lead.gclid,
    sub_id: lead.sub_id,
    // fbp: lead.fbp,
    // gid: lead.gid,
    // lead: isLeadCheckValid ? '1' : '0'
  } as Record<string, string>;

  // If the lead is NOT valid and safe, we send lead data to the landing page so it can be used to fire client side pixels
  // PS: if the lead is valid and safe, we already processed the lead and already fired the client side pixels, we are trying to mitigate the problem with repeated leads
  const hashParams = {} as Record<string, string>;
  if (!store.isLeadValidAndSafe) {
    // hashParams.l_n = lead.hashed_name;
    hashParams.l_e = lead.hashed_email;
  }

  const redirect_url = store.buildRedirectUrl(lead.direct_to || '', additionalParams, hashParams);

  store.resetQuiz();

  // Save email in cookie for 30 days
  // store._setCookie('leadclump_e', lead.email, 30);

  if (window.location !== window.parent.location) {
    window.top!.location.href = redirect_url;
  } else {
    window.location.href = redirect_url;
  }
};


</script>

<template>
  <div class="step step-5 step-form active">
    <h4>{{ gate.title || '' }}</h4>
    <h6 v-if="gate.sub_title">{{ gate.sub_title }}</h6>
    <div class="text-center" v-if="gate.image">
      <img :src="gate.image" :alt="gate.title" />
    </div>
    <p v-if="gate.description">{{ gate.description }}</p>
    <form @submit.prevent="handleSubmit" class="needs-validation novalidate">
      <input
        type="text"
        name="name"
        :placeholder="gate.namePlaceholder"
        :aria-label="gate.namePlaceholder"
        required
        v-model="form.name"
        :title="gate.nameError"
        minlength="3"
      >
      <input
        v-if="gate.usePhone"
        type="tel"
        name="phone"
        placeholder="Digite seu telefone"
        aria-label="Digite seu telefone"
        required
        v-model="form.phone"
      >
      <input
        v-if="gate.useEmail"
        type="email"
        name="email"
        :placeholder="gate.emailPlaceholder"
        :aria-label="gate.emailPlaceholder"
        required
        v-model="form.email"
        pattern="^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$"
        :title="gate.emailError"
      >
      <button type="submit" :disabled="store.fetching" class="cta-button">
        <span v-if="!store.fetching">{{ gate.cta }}</span>
        <span v-else class="loading-content">
          {{ gate.loading }} <font-awesome-icon icon="fas fa-spinner" class="loading-icon" spin />
        </span>
      </button>
      <button
        v-if="quizData.skip && quizData.skip_cta"
        type="button"
        @click="store.handleSkip(false)"
        :disabled="store.fetching"
        class="skip-button"
      >
        {{ quizData.skip_cta }}
      </button>
    </form>
  </div>
</template>